import fetch from '@ixigo/fetch';
import type { ApiErrorResponse } from '@/api';
import { executeApiCall } from '@/api/helper';

export type InitiateRescheduleSuccessResponse = {
	data: {
		success: boolean;
		message: string;
	};
};

export type InitiateRescheduleErrorResponse =
	ApiErrorResponse<InitiateRescheduleErrorType>;
export type InitiateRescheduleResponse =
	| InitiateRescheduleSuccessResponse
	| InitiateRescheduleErrorResponse;

export type InitiateRescheduleErrorType = 'API_ERROR' | 'GENERIC_ERROR';

export const initiateReschedule = async (
	bookingId: string,
	pickupDateTime: string,
	options?: { signal?: AbortSignal },
): Promise<InitiateRescheduleResponse> => {
	return executeApiCall(
		() =>
			fetch
				.post<InitiateRescheduleResponse>('cabs/api/v1/rescheduleBooking', {
					body: JSON.stringify({
						bookingId,
						pickupDateTime: pickupDateTime,
					}),
					headers: {
						'Content-Type': 'application/json',
					},
					signal: options?.signal,
				})
				.json(),
		`initiateReschedule:${bookingId}`,
	);
};
